import React, { useEffect, useState } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import ChatBotLayout from '../layouts/ChatbotLayout'
import LoginAndManufactureLayout from '../layouts/LoginAndManufactureLayout/'
import LoginPage from './Login'
import AdminLoginPage from './AdminLoginPage'
import ProtectedRoutes from './ProtectedRoutes'
import ProtectedAdminRoutes from './ProtectedAdminRoutes'
import { ROUTES } from '../consts/Routes'
import { useAppDispatch, useAppSelector } from '../reducers/hooks'
import { userReducer } from '../reducers/user/userReducer'
import { iframeReducer } from '../reducers/iframe/iframeReducer'
import TermsOfServicePage from './TermsOfServicePage'

const AppRoutes: React.FC = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const connectionMade = useAppSelector((state) => state.iframe.connectionMade)
  const dataReceived = useAppSelector((state) => state.iframe.dataReceived)
  const [connectionAttempts, setConnectionAttempts] = useState(0)

  window.addEventListener('message', (event) => {
    if (event.data === 'chatbotHandshakeFromRN' && window.isfromRN !== true) {
      window.isfromRN = true
      broadcastChatbotReady()
    }
    if (event.data === 'chatbotConnectionMade' && !connectionMade) {
      dispatch(iframeReducer.actions.changeConnectionMade(true))
    }
    if (!dataReceived && connectionMade && (event.data.authToken !== null && event.data.authToken !== undefined)) {
      dispatch(userReducer.actions.changeToken(event.data.authToken))
      localStorage.setItem('token', event.data.authToken)
      dispatch(userReducer.actions.changeSessionId(event.data.sessionId))
      localStorage.setItem('sessionId', event.data.sessionId)
      dispatch(userReducer.actions.changePlatformId(event.data.platformId))
      localStorage.setItem('platformId', event.data.platformId)
      dispatch(userReducer.actions.changeInternalUser(event.data.internalUser ?? 'false'))
      localStorage.setItem('internalUser', event.data.internalUser ?? 'false')
      dispatch(userReducer.actions.changePlatform(event.data.platform))
      localStorage.setItem('platform', event.data.platform)
      dispatch(userReducer.actions.changeUserName(event.data.user_name ?? ''))
      localStorage.setItem('userName', event.data.user_name ?? '')
      dispatch(userReducer.actions.changeEmail(event.data.user_email ?? ''))
      localStorage.setItem('email', event.data.user_email ?? '')
      dispatch(userReducer.actions.changeBotType(event.data.botType ?? ''))
      localStorage.setItem('botType', event.data.botType)
      localStorage.setItem('forceMobileView', event.data.forceMobileView ?? 'false')
      localStorage.setItem('headerColor', event.data.headerColor ?? '')
      localStorage.setItem('logo', event.data.logo ?? '')
      localStorage.setItem('showHeaderLogo', event.data.showHeaderLogo ?? '')
      localStorage.setItem('question', event.data.marketingQuestion ?? '')
      localStorage.setItem('sample_questions', event.data.sampleQuestions ?? '')
      localStorage.setItem('erni_icon', event.data.erniIcon ?? '')
      localStorage.setItem('erni_icon_background', event.data.erniIconBackground ?? '')
      localStorage.setItem('hide_expand_icon', event.data.hideExpandIcon ?? '')
      dispatch(iframeReducer.actions.changeDataReceived(true))
      navigate(ROUTES.CHAT)
    }
    if (event.data === 'clearStorage') {
      localStorage.clear()
      dispatch(iframeReducer.actions.changeDataReceived(false))
    }
  })

  const broadcastChatbotReady = (): void => {
    parent.postMessage('chatbotHandshake', '*')
    if (window.isfromRN === true) parent.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'chatbotHandshake', data: '*' }))
  }

  const broadcastReadyForData = (): void => {
    parent.postMessage('chatbotReadyForData', '*')
    if (window.isfromRN === true) parent.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'chatbotReadyForData', data: '*' }))
  }

  useEffect(() => {
    if (connectionAttempts <= 10) {
      if (!connectionMade) {
        broadcastChatbotReady()
      }
      if (connectionMade) {
        broadcastReadyForData()
      }
      setConnectionAttempts(connectionAttempts + 1)
      if (connectionAttempts > 10) {
        console.log('Maximum number of connection attempts made but no connection was established.')
      }
    }
  }, [connectionMade])

  const loadLocalStorage = (): void => {
    dispatch(userReducer.actions.changeToken(localStorage.getItem('token')))
    dispatch(userReducer.actions.changeSessionId(localStorage.getItem('sessionId')))
    dispatch(userReducer.actions.changePlatform(localStorage.getItem('platform')))
    dispatch(userReducer.actions.changeInternalUser(localStorage.getItem('internalUser')))
    dispatch(userReducer.actions.changeUserName(localStorage.getItem('userName')))
    dispatch(userReducer.actions.changeEmail(localStorage.getItem('email')))
    dispatch(userReducer.actions.changePlatformId(localStorage.getItem('platformId')))
    dispatch(userReducer.actions.changeBotType(localStorage.getItem('botType')))
    dispatch(userReducer.actions.changePlatformNickname(localStorage.getItem('platformNickname')))
  }

  useEffect(() => {
    loadLocalStorage()
  }, [])

  return (
    <Routes>
      <Route element={<ProtectedAdminRoutes />} >
        <Route path={ROUTES.ADMIN_LOGIN} element={<LoginAndManufactureLayout />}>
          <Route index element={<AdminLoginPage />} />
        </Route>
      </Route>
      <Route element={<ProtectedRoutes />} >
        <Route path={ROUTES.CHAT} element={<ChatBotLayout />} />
      </Route>
      <Route path={ROUTES.HOME} element={<LoginAndManufactureLayout />}>
        <Route index element={<LoginPage />} />
      </Route>
      <Route path={ROUTES.HOME + '/:token/:plid/:sessionId'} index element={<ChatBotLayout />} />
      <Route path={ROUTES.HOME + '/chatbottermsofservice'} index element={<TermsOfServicePage />} />
    </Routes>
  )
}

export default AppRoutes
